export const URL = {
  BASE: 'https://team-project-react-nodejs-backend.onrender.com/api',
  USERS: '/users',
  NOTICES: '/notices',
  FRIENDS: '/ours_friends',
  FAVORITES: '/favorites',
  OWNADS: '/my_notices',
  NEWS: '/news',
  PETS: '/pets',
  QUERY: 'query=',
  SALE: '?category=sale',
  FOUND: '?category=lostFound',
  HANDS: '?category=inGoodHands',
  REGISTRATION: 'registration',
  LOGIN: '/login',
  LOGOUT: '/logout',
  CURRENT: '/current',
  PROFILE: '/profile',
  AVATAR: '/avatar',
  FORGOT: '/forgot_password',
};

export const CITIES_URL =
  'https://team-project-react-nodejs-backend.onrender.com/api/cities_of_ukraine';
